module.exports = __webpack_public_path__ + "img/Proliferation-LICA_GSE146409.ec3b4b6a.png";